// extracted by mini-css-extract-plugin
export default {"discount-container":"GCRC1","name-input":"ZVRVV","radio-buttons":"j6iA2","amount-input":"BewsE","rhs":"mI0Gk"};